export default {
  CONTACT_SALES_FORM_ID: process.env.CONTACT_SALES_FORM_ID,
  CONTACT_SUCCESS_FORM_ID: process.env.CONTACT_SUCCESS_FORM_ID,
};
